import React, { memo, useCallback } from 'react'
import { FormRendererProps } from '../types/FormRenderer'
import { Input } from '../../irv-ui'

const FormTextRenderer: React.FC<FormRendererProps> = ({
  id,
  value,
  readonly,
  className,
  onChange,
  onCommit,
}) => {
  const handleBlur = useCallback(
    e => {
      if (onCommit) {
        onCommit(e.target.value)
      }
    },
    [onCommit],
  )

  if (readonly) {
    return <div className={className}>{value}</div>
  }

  return (
    <Input
      id={id}
      value={value || ''}
      className={className}
      onChange={onChange}
      onBlur={handleBlur}
    />
  )
}

export default memo(FormTextRenderer)
